import React from 'react';
import Button from 'components/CustomButtons/Button';
import { translate } from 'components/Translation';
import { makeStyles } from '@material-ui/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/tryAndBuy/tryAndBuyStyle';
import { BodyMBold, DisplayS } from 'components/Typography/Typography';
import { useState } from 'react';
import FBBDialog from 'components/TryAndBuy/FBBDialog';

type DialogType = 'tryNowFBB' | null;

// @ts-ignore
const useStyles = makeStyles(styles);

interface ActiveServiceProps {
	serviceName: string;
	servicePeriod: string;
}

const ActiveService = (props: ActiveServiceProps) => {
	const { serviceName, servicePeriod } = props;
	const classes = useStyles();
	const [dialog, setDialog] = useState<DialogType>(null);

	const handleTryNow = () => {
		setDialog('tryNowFBB');
	};

	const hideDialog = () => {
		setDialog(null);
	};

	return (
		<>
			<div className={classes.wrapper} onClick={handleTryNow}>
				<div className={classes.serviceWrapper}>
					<DisplayS disableMargin inline>
						{serviceName}
					</DisplayS>
					<BodyMBold color="disabled-light" disableMargin>
						{servicePeriod}
					</BodyMBold>
				</div>
				<Button color="primary-light" className={classes.tryNowButton} onClick={handleTryNow}>
					<>{translate('tryandbuy.tryNowButton')}</>
				</Button>
			</div>

			<FBBDialog hideDialog={hideDialog} header={serviceName} isOpen={dialog === 'tryNowFBB'} />
		</>
	);
};

export default ActiveService;
